/* eslint-disable @typescript-eslint/no-explicit-any */

import { QueryParams } from 'use-query-params';
import { IPaginationQueryParams, getPaginationQueryParams } from '../common/constants/pagination';
import { OrderDirection } from '../common/enums/order-direction.enum';
import { IHOCQueryProps } from '../common/interfaces/IHOCQueryProps';
import EntryTable from './EntryTable';

export interface EntryTableQueryPrps extends IPaginationQueryParams {
}

export type EntryTableBasicProps = IHOCQueryProps<EntryTableQueryPrps>;

const DEFAULT_QUERY_PARAMS = getPaginationQueryParams({
  orderBy: 'id',
  orderDirection: OrderDirection.ASC,
});

const EntryTableWithQueryParams = () => {
  const queryConfig = {
    ...DEFAULT_QUERY_PARAMS,
  };

  return (
    <QueryParams config={queryConfig}>
      {(props: any) => {
        return <EntryTable {...props} />;
      }}
    </QueryParams>
  );
};

export default EntryTableWithQueryParams;
